import { IconProps } from "./types";

// Native aspect ratio of the design spec's SVG — non-square, so `size` maps
// to width and height is derived to avoid distorting the glyph.
const VIEWBOX_WIDTH = 12;
const VIEWBOX_HEIGHT = 14;

/** Bold direction arrow with its own base line beneath it (distinct from
 * ChevronDownIcon's navigational chevron) — used inside DropoffMarker. */
export const ArrowDownIcon = ({ size = VIEWBOX_WIDTH, color = "currentColor", className }: IconProps) => {
  const height = size * (VIEWBOX_HEIGHT / VIEWBOX_WIDTH);

  return (
    <svg
      width={size}
      height={height}
      viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.913 10.566c-.251 0-.492-.09-.669-.249L1.151 6.644a.782.782 0 0 1 .002-1.193c.37-.33.967-.329 1.336.001l2.48 2.227V.844c0-.466.424-.844.945-.844s.944.378.944.844v6.835l2.484-2.227c.37-.33.966-.33 1.336-.001s.37.863.002 1.193l-4.073 3.65a1 1 0 0 1-.694.271"
        fill={color}
      />
      <path
        opacity=".4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.885 13.5H.945c-.523 0-.945-.378-.945-.844s.422-.844.944-.844h9.94c.522 0 .945.379.945.844 0 .466-.423.844-.944.844"
        fill={color}
      />
    </svg>
  );
};
